import React from 'react';

export default function Skills() {
    return (
        <section id="skills" className="mb-12 px-4 sm:px-6 lg:px-8">
            <h2 className="text-2xl sm:text-3xl font-bold mb-6 pb-2 border-b-2 border-blue-500">
                SKILLS
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                <div className="bg-white p-6 rounded-lg shadow-md">
                    <h3 className="font-bold text-lg sm:text-xl mb-3 text-blue-800">Soft Skills</h3>
                    <p className="text-sm sm:text-base">Self-motivation, Communication, Flexibility, Positive Attitude, Adaptable, Teamwork, Openness to personal growth</p>
                </div>
                <div className="bg-white p-6 rounded-lg shadow-md">
                    <h3 className="font-bold text-lg sm:text-xl mb-3 text-blue-800">Technical Skills</h3>
                    <p className="text-sm sm:text-base">Python, C/C++ (Basic), SQL (Basic), HTML (Basic)</p>
                </div>
                <div className="bg-white p-6 rounded-lg shadow-md sm:col-span-2">
                    <h3 className="font-bold text-lg sm:text-xl mb-3 text-blue-800">Tools & Technologies</h3>
                    <p className="text-sm sm:text-base">Jupyter Notebook, Mobaxterm, SSH, Github, Git, Word, Excel, Visual Studio Code, LaTeX, Overleaf, Linux</p>
                </div>
            </div>
        </section>
    );
}
